import FAQPage from './FAQPage';
export default FAQPage;
export { default as getData } from './getData';